import { NavLink } from "react-router-dom";
import styled from "styled-components";

export default function NavBar() {
    return (
        <NavContainer>
            <StyledNavLink to="/" end>Home</StyledNavLink>
            <StyledNavLink to="/aboutus">Über uns</StyledNavLink>
            <StyledNavLink to="/contact">Kontakt</StyledNavLink>
        </NavContainer>
    );
}

const NavContainer = styled.nav`
    display: flex;
    flex-wrap: wrap;                 /* ✅ darf umbrechen */
    justify-content: space-evenly;
    align-items: center;
    gap: 0.75rem 1rem;               /* Zeilen- und Spaltenabstand */
    padding: 0.75rem 1rem;
    background-color: #fff;
    width: 100%;
    position: relative;
    z-index: 10;

    @media (max-width: 768px) {
        gap: 0.5rem 0.75rem;
        padding: 0.5rem 0.75rem;
    }
`;

const StyledNavLink = styled(NavLink)`
    /* Keine fixe width/height → wächst nur mit Inhalt */
    display: inline-flex;
    align-items: center;
    justify-content: center;

    padding: 0.6rem 0.9rem;          /* angenehme Klickfläche */
    border-radius: 6px;
    font-weight: 600;
    line-height: 1;                  /* kompakt */
    text-decoration: none;
    white-space: nowrap;             /* nicht in der Mitte umbrechen */
    box-shadow: 0 4px 6px rgba(0,0,0,.1);
    margin-top: -6rem;
    margin-bottom: -6rem;


    background-color: #005fad;
    color: #fff;
    transition: transform .2s ease, background-color .2s ease, color .2s ease;

    &:hover {
        background-color: #ffda2a;
        color: #1a202c;
        transform: scale(1.04);        /* dezentes Hover */
    }

    &.active {
        outline: 2px solid #ffda2a;    /* aktive Markierung */
        outline-offset: 2px;
    }

    /* Mobile: noch kompakter & kein Scale (verhindert „größer werden“) */
    @media (max-width: 768px) {
        padding: 0.5rem 0.75rem;
        font-size: 0.95rem;
        transform: none;
        &:hover {
            transform: none;
        }
    }
`;
